import { gql } from '@apollo/client';

export const GET_FACETS = gql`
  query getFacets($input: GetAllFlyersInput!) {
    getFacets(input: $input) {
      facets {
        categories {
          key
          count
        }
        priceType {
          key
          count
        }
        owningType {
          key
          count
        }
        grades {
          key
          count
        }
      }
      pagination {
        total
      }
    }
  }
`;
